// Bridge — reads everything from public/runtime-config.js.
// To change any config value: edit public/runtime-config.js (dev) or
// build/runtime-config.js (after deployment). No rebuild needed.
if (!window.__KLIMAVIEWER_RUNTIME_CONFIG__) {
  console.error(
    "[config] window.__KLIMAVIEWER_RUNTIME_CONFIG__ is not defined. " +
      "Make sure build/runtime-config.js exists and is loaded before the app bundle."
  );
}

const cfg = window.__KLIMAVIEWER_RUNTIME_CONFIG__ || {};
const ep = cfg.endpoints || {};

// ----------------------------------------------------------
// Backend API base URL
// ----------------------------------------------------------
export const baseBackendUrl = (cfg.baseBackendUrl || "").replace(/\/+$/, "");

// ----------------------------------------------------------
// Backend API endpoints
// ----------------------------------------------------------
export const endpoints = {
  servicesUrl: ep.servicesUrl,
  serviceItemsUrl: (serviceId) =>
    `${ep.serviceItemsUrl}/${encodeURIComponent(serviceId)}`,
  serviceItemUrl: (serviceId, objectId) =>
    `${ep.serviceItemUrl}/${encodeURIComponent(serviceId)}/${encodeURIComponent(
      objectId
    )}`,
  niklisParametersConfigUrl: ep.niklisParametersConfigUrl,
  klimaStatisticsUrl: ep.klimaStatisticsUrl,
  backendVersionUrl: ep.backendVersionUrl,
  databaseVersionUrl: ep.databaseVersionUrl,
};

// ----------------------------------------------------------
// UI links
// ----------------------------------------------------------
export const helpUrl = cfg.helpUrl;
export const downloadUrl = cfg.downloadUrl;
export const feedbackUrl = cfg.feedbackUrl;

// ----------------------------------------------------------
// Search React widget settings - Location search (see src/components/searchReact/src/Widget.js)
// ----------------------------------------------------------
export const locationSearchUrl = cfg.locationSearchUrl;
export const locationSearchProxyUrl = cfg.locationSearchProxyUrl;

// ----------------------------------------------------------
// External institution links
// ----------------------------------------------------------
export const niedersachsenEnvUrl = cfg.niedersachsenEnvUrl;
export const nikoUrl = cfg.nikoUrl;
export const nlwknUrl = cfg.nlwknUrl;
export const lbegUrl = cfg.lbegUrl;

// ----------------------------------------------------------
// Map services
// ----------------------------------------------------------
export const geometryServiceUrl = cfg.geometryServiceUrl;
// WMS proxy (used by ExternLayers widget)
export const wmsProxyUrl = cfg.wmsProxyUrl;
// Overview map — the feature layer that shows the Niedersachsen outline
export const overviewMapLayerUrl = cfg.overviewMapLayerUrl;

// ----------------------------------------------------------
// Editor widget settings
// ----------------------------------------------------------
export const allowMultiparts = cfg.allowMultiparts ?? false;
export const proxyUrl = cfg.proxyUrl || "";

// ---------------------------------------------------------------------------
// Geographic selection defaults
// These values are used by URLParameterController for initialization and by ZoomToGeo as fallback when used standalone.
// ---------------------------------------------------------------------------
export const REGIONAL_SELECTION_DEFAULTS = cfg.regionalSelectionDefaults || {
  source: "Bundesland",
  entity: "Niedersachsen",
  allowedEntities: ["Niedersachsen"],
};

// Default export: the full raw config object.
// Use this for any NEW keys so you only need to add them to public/runtime-config.js —
// no change to this file required.
// Example: import runtimeConfig from "configs/config"; runtimeConfig.myNewKey
export default cfg;
